module.exports = __webpack_public_path__ + "static/media/rolling.99330416.gif";